export default {
    我已阅读并同意: '我已阅读并同意',
    用户协议: '用户协议',
    隐私声明: '隐私声明',
    '，并授权复星财富获得MyLink登录手机号': '，并授权复星财富获得MyLink登录手机号',
    '登录/注册': '登录/注册',
    请阅读并勾选用户协议: '请阅读并勾选用户协议',
    '服务器连接中，请稍后再试': '服务器连接中，请稍后再试',
    '当前系统版本过低，请升级': '当前系统版本过低，请升级\n手机系统版本至最新版本',
    '暂不支持当前账户类型通过MyLink使用复星财富服务。': '暂不支持当前账户类型通过MyLink使用复星财富服务。',
    '如有疑问，请致电': '如有疑问，请致电',
    '联系复星财富客服。': '联系复星财富客服。',
}
